// Mirrors the render-time protocol allowlist in `RichTextParserHelper`
// (`iframe` src => http, https, relative). Keep the two in sync.
const ALLOWED_EMBED_PROTOCOLS = new Set(["http", "https"])

const SCHEME_PATTERN = /^([a-z][a-z0-9+.-]*):/i

// Browsers strip tabs, newlines and carriage returns from anywhere in a URL and
// trim leading control characters, so `java&#9;script:alert(1)` navigates exactly
// like `javascript:alert(1)`. Read the scheme from the stripped value or the
// check is trivially bypassed; the caller still uses the original string.
function schemeOf(value) {
  const stripped = value.replace(/[\u0000-\u0020\u007f]/g, "")

  return stripped.match(SCHEME_PATTERN)?.[1]?.toLowerCase() || null
}

// A URL is safe to hand to a live embed only when it has no scheme (relative and
// protocol-relative URLs inherit the page's) or an allowlisted one.
//
// `javascript:` is the case that matters: an iframe navigated there executes
// script against this origin, and our CSP sets `unsafe_inline` on script-src so
// it offers no protection. `data:` gets an opaque origin in modern browsers but
// still renders attacker markup inside a trusted page, so it stays out too.
export function isAllowedEmbedURL(value) {
  if (typeof value !== "string" || value.trim() === "") return false

  const scheme = schemeOf(value)

  return scheme === null || ALLOWED_EMBED_PROTOCOLS.has(scheme)
}
